/*
 * contractsApi.ts
 * Ressource API pour les contrats
 */

import { ContractData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const contractsApi = apiResource<ContractData>('contracts');
